var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"title",class:[`title--${_vm.size}`, _vm.margin ? 'has-margin' : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }